import React from 'react';

import useTeamRefreshGuid from '../../../../hooks/useTeamRefreshGuid';
import { team_subscription_path } from '../../../../routes';
import { Team } from '../../../../utils/backend-api/teams';
import LinkCopy from '../../../BaseUI/LinkCopy';
import SettingsHeading from '../SettingsHeading';
import styles from './styles.module.scss';

export default function SignupLink({ team }: { team: Team }) {
  const { refreshTeamGuid, isRefreshTeamGuidLoading } = useTeamRefreshGuid();

  const onClickRefresh = () => {
    if (confirm('Are you sure you want to refresh the signup link?') == true) {
      refreshTeamGuid();
    }
  };

  return (
    <>
      <SettingsHeading title="Team Signup Link" />
      <div className="TextField !mt-0">
        <div className="label-description">
          Allow anyone with this link to sign up for The Information and be automatically added to
          my account.
        </div>
        <div className={styles.signupLinkContainer}>
          <LinkCopy
            clipboardLink={`${window.location.origin}${team_subscription_path(team.guid)}`}
            trackingProps={{
              'ahoy-name': 'Team Signup Link',
              location: 'settings',
              name: 'team_signup_link',
            }}
          />
        </div>
        <div>
          <button
            className={styles.linkRefresh}
            onClick={onClickRefresh}
            disabled={isRefreshTeamGuidLoading}
          >
            Refresh
          </button>
        </div>
      </div>
    </>
  );
}
